export default __webpack_public_path__ + "img/450d15f9009b8d6c00a4625323a76baf.svg";